import AxiosGlobalInstance, { AxiosPromise, IConsorcieiResponse } from '@/services/index';
import { stripHtml } from '@/libs/utils';

interface ICheckFastinExistsOffer {
  admId: string;
  group: string;
  share: string;
  documentNumber: string;
  name: string;
  email: string;
}

export const getFastinExistsOffer =
  (data: ICheckFastinExistsOffer): AxiosPromise<IConsorcieiResponse<Record<string, unknown>>> => {
    return AxiosGlobalInstance.get(`/fastin/exists`, {
      params: {
        admId: data.admId,
        group: data.group,
        share: data.share,
        documentNumber: data.documentNumber,
        name: stripHtml(data.name),
        email: stripHtml(data.email)
      }
    });
  };
